import { Modal } from "@mui/material";
import styles from "./Ongoing.module.css";
import ongoingImage from "../../../../assets/images/ongoing.svg";
import { useLocation, useNavigate } from "react-router-dom";

const Ongoing = ({ open, onClose }) => {
  const navigate = useNavigate();
  let location = useLocation();
  let listingId = location?.search?.split("=")[1];

  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.modal}>
        <div className={styles.emptyState}>
          <img
            style={{ marginBottom: "10px" }}
            src={ongoingImage}
            alt="No Available Listings"
          />
          <h2>Connection Moved to Ongoing </h2>

          <p>
            Your documentation is complete, and this connection has been moved
            to{" "}
            <span style={{ color: "var(--primary-color-text)" }}>Ongoing</span>.
            You can now track your power transaction here.
          </p>

          <div>
            <div
              className={styles.addListingButton}
              onClick={() => {
                navigate(`/ongoing?id=${listingId}`);
              }}
            >
              <span>Go to Ongoing</span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Ongoing;
